import React from 'react';
import { LinearProgress as MuiLinearProgress } from '@material-ui/core';

export const LinearProgress = (props) => {
    return <MuiLinearProgress {...props} />
};